import InfoComponent from './InfoComponent';

export default InfoComponent;
